import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import OurStory from "./pages/OurStory";
import WhatWeDo from "./pages/WhatWeDo";
import Partners from "./pages/Partners";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Header />
              <div className="pt-20">
                <Home />
              </div>
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Header />
              <div className="pt-20">
                <About />
              </div>
              <Footer />
            </>
          } />
          <Route path="/our-story" element={
            <>
              <Header />
              <div className="pt-20">
                <OurStory />
              </div>
              <Footer />
            </>
          } />
          <Route path="/what-we-do" element={
            <>
              <Header />
              <div className="pt-20">
                <WhatWeDo />
              </div>
              <Footer />
            </>
          } />
          <Route path="/partners" element={
            <>
              <Header />
              <div className="pt-20">
                <Partners />
              </div>
              <Footer />
            </>
          } />
          <Route path="/careers" element={
            <>
              <Header />
              <div className="pt-20">
                <Careers />
              </div>
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <div className="pt-20">
                <Contact />
              </div>
              <Footer />
            </>
          } />
        </Routes>
        <Toaster position="top-right" />
      </HashRouter>
    </div>
  );
}

export default App;
